var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 13.3438L17.5872 9.5L10.9375 5.65625V13.3438ZM25.7487 3.31156C25.9153 3.91375 26.0306 4.72094 26.1075 5.74594C26.1972 6.77094 26.2356 7.655 26.2356 8.42375L26.3125 9.5C26.3125 12.3059 26.1075 14.3687 25.7487 15.6884C25.4284 16.8416 24.6853 17.5847 23.5322 17.905C22.93 18.0716 21.8281 18.1869 20.1369 18.2638C18.4713 18.3534 16.9466 18.3919 15.5372 18.3919L13.5 18.4688C8.13156 18.4688 4.7875 18.2638 3.46781 17.905C2.31469 17.5847 1.57156 16.8416 1.25125 15.6884C1.08469 15.0863 0.969375 14.2791 0.8925 13.2541C0.802813 12.2291 0.764375 11.345 0.764375 10.5763L0.6875 9.5C0.6875 6.69406 0.8925 4.63125 1.25125 3.31156C1.57156 2.15844 2.31469 1.41531 3.46781 1.095C4.07 0.928438 5.17188 0.813125 6.86313 0.73625C8.52875 0.646562 10.0534 0.608125 11.4628 0.608125L13.5 0.53125C18.8684 0.53125 22.2125 0.73625 23.5322 1.095C24.6853 1.41531 25.4284 2.15844 25.7487 3.31156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/YoutubeLogo.8ea048cbd759363b3f068fe2e6da344e.svg";
export { ForwardRef as ReactComponent };